import React from 'react';
import { Link } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import Branches from '../components/Branches';
import { CMSArticleSection } from '../components/CMSArticleSection';
import { ArrowLeft } from 'lucide-react';

const BranchesPage = () => {
  return (
    <div className="min-h-screen bg-white" data-testid="branches-page">
      <Header />
      <div className="max-w-7xl mx-auto px-4 pt-6">
        <Link to="/" className="inline-flex items-center gap-2 text-[#1565C0] hover:text-orange-600 text-sm font-bold">
          <ArrowLeft className="w-4 h-4" /> Back to Home
        </Link>
      </div>

      {/* Branch grid — all 18 branches nationwide */}
      <Branches />

      {/* Branch Activities articles */}
      <CMSArticleSection
        anchor="branch-activities"
        slug="branch-activities"
        eyebrow="Nationwide Activities"
        title="Branch"
        accent="Activities"
        subtitle="Highlights from EWRF branches across Malaysia."
      />

      <Footer />
    </div>
  );
};

export default BranchesPage;
